import { GuestAccessList as List } from 'ui-components'
import { removeMapAccess } from '~map-preview/api/removeMapAccess'
import { useGetMapById } from '~map-preview/queries/useGetMapById'
import { useMap } from '~map-preview/states/map'

function GuestAccessList() {
  const map = useMap()
  const { refetch } = useGetMapById(map.id)

  const handleRemoveAccessClick = async (access) => {
    await removeMapAccess({ id: access.id })
    await refetch()
  }

  return (
    <List
      accesses={map?.mapGuestAccessCollection?.items || []}
      onRemoveAccessClick={handleRemoveAccessClick}
    />
  )
}

export { GuestAccessList }
